import $ from 'jquery';
import React, { useEffect, useState } from 'react';
import MobileNav from '../../components/MobileNav/MobileNav';
import ReserveForm from './ReserveForm';

const Header02 = () => {
    useEffect(() => {
        // Toggle Header Search
        $('.header_search .form-control-submit').click(function (e) {
            $('.open_search').toggleClass('active');
        });

        // Header Sticky
        var header = $(".header");
        $(window).scroll(function () {
            var scroll = $(window).scrollTop();

            if (scroll >= 120) {
                header.addClass("sticky");
            } else {
                header.removeClass("sticky");
            }
        });
    }, []);

    //ReserveForm PopUP 
    const [isAdd, setAdd] = useState("false");
    const handleAddCss = () => {
        setAdd(!isAdd);
    };

    // Cart Wishlist
    const [isActive, setActive] = useState('true');
    const handleToggle = () => {
        setActive(!isActive);
    };

    return (
        <>
            <header className="header header_type2">
                <div className="top_bar">
                    <div className="container-fluid">
                        <div className="top_bar_inner">
                            <div className="logo">
                                <a href="/"><img src="images/logo.svg" alt="logo" /></a>
                            </div>

                            <div className="mainnav">
                                <ul className="main_menu">
                                    <li className="menu-item menu-item-has-children active"><a href="/">Home</a>
                                        <ul className="sub-menu">
                                            <li className="menu-item active"><a href="/home-2">Home 2</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item menu-item-has-children"><a href="/#">Menu</a>
                                        <ul className="sub-menu">
                                            <li className="menu-item"><a href="/menu1">Menu 1</a></li>
                                            <li className="menu-item"><a href="/menu2">Menu 2</a></li>
                                            <li className="menu-item"><a href="/menu3">Menu 3</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item menu-item-has-children"><a href="/#">Pages</a>
                                        <ul className="sub-menu">
                                            <li className="menu-item"><a href="/about">About</a></li>
                                            <li className="menu-item"><a href="/team">Team</a></li>
                                            <li className="menu-item"><a href="/gallery">Gallery</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item menu-item-has-children"><a href="/#">Shop</a>
                                        <ul className="sub-menu">
                                            <li className="menu-item menu-item-has-children"><a href="/#">Grid</a>
                                                <ul className="sub-menu">
                                                    <li className="menu-item"><a href="/shop-3col">3 Columns</a></li>
                                                    <li className="menu-item"><a href="/shop-4col">4 Columns</a></li>
                                                </ul>
                                            </li>
                                            <li className="menu-item"><a href="/single-product">Single Product</a></li>
                                            <li className="menu-item"><a href="/cart">Cart</a></li>
                                            <li className="menu-item"><a href="/checkout">Checkout</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item menu-item-has-children"><a href="/#">Blog</a>
                                        <ul className="sub-menu">
                                            <li className="menu-item"><a href="/blog-standard">Standard</a></li>
                                            <li className="menu-item"><a href="/blog-classNameic">classNameic</a></li>
                                            <li className="menu-item"><a href="/blog-grid">Grid</a></li>
                                            <li className="menu-item"><a href="/blog-details">Details</a></li>
                                            <li className="menu-item"><a href="/blog-details-with-sidebar">Details With Sidebar</a></li>
                                        </ul>
                                    </li>
                                    <li className="menu-item menu-item-has-children"><a href="/#">Contact</a>
                                        <ul className="sub-menu">
                                            <li className="menu-item"><a href="/contact1">Contact 1</a></li>
                                            <li className="menu-item"><a href="/contact2">Contact 2</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                            <div className="header_toggle d-xl-none">
                                {/* <!-- Mobile Responsive Menu Toggle Button --> */}
                                <button type="button" className="mr_menu_toggle">
                                    <span className="toggle_line"></span>
                                    <span className="toggle_line"></span>
                                    <span className="toggle_line"></span>
                                </button>
                            </div>

                            <div className="nav_more_info">
                                <div onClick={handleToggle} className="element">
                                    <a className="cart_icon"><i className="icon-basket"></i> <span className="count">2</span></a>
                                    <a href="/#" className="wishlist_icon"><i className="icon-heart"></i></a>
                                    <div className={isActive ? null : "active"} id="cart_box">
                                        <div className="grand_total">
                                            <ul>
                                                <li>Swiss Hash Browns <span className="value">$154</span></li>
                                                <li>Spaghetti carbonara<span className="value">$220</span></li>
                                                <li className="totalvalue">Total <span className="value">$374</span></li>
                                            </ul>
                                            <div className="button_group">
                                                <input className="button" type="submit" value="Checkout" name="submit" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* <!-- Reservation Popup --> */}
                                <div onClick={handleAddCss} className="reserve_button_group d-none d-md-block">
                                    <a className="button">Reserve A Table</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <ReserveForm handleAddCss={handleAddCss} isAdd={isAdd} />
            <MobileNav />
        </>
    );
};

export default Header02;